<template>
  <div class="modal-title-bar">
    <div class="title">{{ title }}</div>
    <div v-if="hasButtons" class="buttons">
      <slot name="buttons"></slot>
    </div>
    <close-button @close="$emit('close')"></close-button>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  computed: {
    hasButtons: function() {
      return !!this.$slots.buttons;
    },
  },
  emits: ["close"],
};
</script>
<style lang="scss" scoped>
@import "@/_css/variables";

.modal-title-bar {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 5px;
  margin-bottom: 10px;
  background-color: $gray-300;
  border-radius: 5px;

  & > .title {
    font-size: 0.8rem;
    font-weight: bold;
  }

  & > .buttons {
    & > button {
      margin-left: 3px;

      &:first-child {
        margin-left: 0;
      }
    }
  }
}
</style>
